let devRoles = {};

// webpack replaces process.env.NODE_ENV with "production" at build time,
// making this condition statically false — Terser eliminates the entire block
if (process.env.NODE_ENV === "development") {
  devRoles = {
    teacherPro: {
      login: process.env.VUE_APP_TEACHER_PRO_LOGIN,
      pass: process.env.VUE_APP_TEACHER_PRO_PASSWORD,
      label: "Pro teacher",
      value: "teacherPro",
    },
    audit: {
      login: process.env.VUE_APP_AUDITOR_LOGIN,
      pass: process.env.VUE_APP_AUDITOR_PASSWORD,
      label: "Audit",
      value: "audit",
    },
    academymanager: {
      login: process.env.VUE_APP_ACADEMY_MANAGER_LOGIN,
      pass: process.env.VUE_APP_ACADEMY_MANAGER_PASSWORD,
      label: "Academy manager",
      value: "academymanager",
    },
    admin: {
      login: process.env.VUE_APP_ADMIN_LOGIN,
      pass: process.env.VUE_APP_ADMIN_PASSWORD,
      label: "Admin",
      value: "admin",
    },
    kurator: {
      login: process.env.VUE_APP_KURATOR_LOGIN || "",
      pass: process.env.VUE_APP_KURATOR_PASSWORD || "",
      label: "Kurator",
      value: "kurator",
    },
    instructor: {
      login: process.env.VUE_APP_INSTRUCTOR_LOGIN,
      pass: process.env.VUE_APP_INSTRUCTOR_PASSWORD,
      label: "Instructor",
      value: "instructor",
    },
    callCenter: {
      login: process.env.VUE_APP_CALL_CENTER_LOGIN,
      pass: process.env.VUE_APP_CALL_CENTER_PASSWORD,
      label: "Call center",
      value: "callCenter",
    },
    examiner: {
      login: process.env.VUE_APP_EXAMINER_LOGIN,
      pass: process.env.VUE_APP_EXAMINER_PASSWORD,
      label: "Examiner",
      value: "examiner",
    },
    finance: {
      login: process.env.VUE_APP_FINANCE_LOGIN,
      pass: process.env.VUE_APP_FINANCE_PASSWORD,
      label: "Finance",
      value: "finance",
    },
    marketing: {
      login: process.env.VUE_APP_MARKETING_LOGIN,
      pass: process.env.VUE_APP_MARKETING_PASSWORD,
      label: "Marketing",
      value: "marketing",
    },
    axo: {
      login: process.env.VUE_APP_AXO_LOGIN,
      pass: process.env.VUE_APP_AXO_PASSWORD,
      label: "Axo",
      value: "axo",
    },
    tutor: {
      login: process.env.VUE_APP_TUTOR_LOGIN,
      pass: process.env.VUE_APP_TUTOR_PASSWORD,
      label: "Tutor",
      value: "tutor",
    },
    moderator: {
      login: process.env.VUE_APP_MODERATOR_LOGIN,
      pass: process.env.VUE_APP_MODERATOR_PASSWORD,
      label: "Blog Moderator",
      value: "moderator",
    },
    branchacademy: {
      login: process.env.VUE_APP_BRANCHACADEMY_LOGIN || "",
      pass: process.env.VUE_APP_BRANCHACADEMY_PASSWORD || "",
      label: "Branch Academy",
      value: "branchacademy",
    },
    bi: {
      login: process.env.VUE_APP_BI_LOGIN || "",
      pass: process.env.VUE_APP_BI_PASSWORD || "",
      label: "BI",
      value: "bi",
    },
    hr: {
      login: process.env.VUE_APP_HR_LOGIN || "",
      pass: process.env.VUE_APP_HR_PASSWORD || "",
      label: "HR",
      value: "hr",
    },
    metodist: {
      login: process.env.VUE_APP_METODIST_LOGIN || "",
      pass: process.env.VUE_APP_METODIST_PASSWORD || "",
      label: "Metodist",
      value: "metodist",
    },
    itSupport: {
      login: process.env.VUE_APP_METODIST_LOGIN || "",
      pass: process.env.VUE_APP_METODIST_PASSWORD || "",
      label: "IT Support",
      value: "itSupport",
    },
  };
}

export default {
  state() {
    return {
      roles: devRoles,
      backRoles: {
        0: "Manager",
        1: "Employee",
        2: "Instructor",
        3: "CEO",
        4: "Auditor",
        5: "Examiner",
        6: "Kurator",
        7: "AXO",
        8: "Hunter",
        9: "Tutor",
        10: "Parent",
        11: "Branch",
        12: "Moderator",
        13: "Analytic",
        14: "IT Support",
      },
      departments: {
        0: "Head",
        1: "Sales",
        2: "HR",
        3: "Marketing",
        4: "General",
        5: "Academy",
        6: "Finance",
      },
    };
  },
};
